import { render } from "./Detail.vue?vue&type=template&id=fb9b7614&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=fb9b7614&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb9b7614"

export default script